import fireplace from "./fireplace.jsx";
import lavaspurt from "./lavaspurt.jsx";
import waterspurt from "./waterspurt.jsx";

export default {
  fireplace,
  lavaspurt,
  waterspurt,
};
